<template>
  <div class="card-form">
    <form @submit.prevent="checkForm" class="card-form-wrapper">
      <H1>Contact Us</H1>
      <TextInput
        v-model="name"
        name="name"
        label="Name"
        type="text"
        :error="errors['name']"
        @input="removeErrorMessage('name', $event)"
      />
      <TextInput
        v-model="email"
        name="email"
        label="Email"
        type="email"
        :error="errors['email']"
        @input="removeErrorMessage('email', $event)"
      />
      <Phone
        v-model="phone"
        name="phone"
        label="Phone"
        type="text"
        :error="errors['phone']"
        @input="removeErrorMessage('phone', $event)"
      />
      <TextArea 
        v-model="message"
        name="message"
        label="Message"
        :error="errors['message']"
        :rows="7"
        @input="removeErrorMessage('message', $event)" />
      <div class="contact-form-cta"> 
        <Button :loading="loading" class="red">Submit</Button>
      </div>
    </form>
  </div>
</template>

<script>
import { 
  H1,
  TextInput, 
  Button,
  TextArea,
  Phone
} from "../../style";
import { mapActions } from "vuex";
import { SEND_MESSAGE } from "../../store/types";
export default {
  name: "Contact",
  components: {
    H1,
    TextInput,
    Button,
    TextArea,
    Phone
  },
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      message: "",
      errors: {
        name: "",
        email: "",
        phone: "",
        message: ""
      },
      loading: false
    };
  },
  mounted() {
    document.title = "Contact | Dremca Insurance";
  },
  beforeDestroy() {
    document.title = "Dremca | Insurance"
  },
  methods: {
    ...mapActions({
      sendMessage: SEND_MESSAGE
    }),
    checkForm() {
      let preventSubmit = false;

      if (this.name.trim().length == 0) {
        preventSubmit = true;
        this.errors["name"] = "Name is required";
      }

      if (this.email.trim().length == 0) {
        preventSubmit = true;
        this.errors["email"] = "Email is required";
      }

      if (this.message.trim().length == 0) {
        preventSubmit = true;
        this.errors["message"] = "Message is required";
      }

      if (!preventSubmit) {
        let data = {
          name: this.name,
          email: this.email,
          phone: this.phone,
          message: this.message
        }
        this.loading = true;
        this.sendMessage({
          data
        })
          .then(() => {
            this.$notify({
              type: "success",
              title: "Success",
              message: "Message sent"
            });
            this.reset();
          })
          .catch(() => {});
      }
    },
    removeErrorMessage(field, value) {
      if (value.trim().length) {
        this.errors[field] = "";
      }
    },
    reset() {
      this.loading = false;
      this.name = "";
      this.email = "";
      this.phone = "";
      this.message = "";
    }
  }
}
</script>